"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hrLinkageSearchReducer = exports.hrLinkageSearchActions = exports.TYPES = exports.PERMISSION_KEY = exports.LINKAGE_STATUS_CODE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'hrLinkageSearch';

// アクションタイプ
const TYPES = exports.TYPES = {
  GO_MAIN: PREFIX + 'goMain',
  GO_UPDATE: PREFIX + 'GoUpdate',
  GO_RESULT: PREFIX + 'goResult',
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  CHANGE_CURRENT_PAGE: PREFIX + 'ChangeCurrentPage',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  CHANGE_SITE: PREFIX + 'ChangeSite',
  SET_SITE_INFO: PREFIX + 'SetSiteInfo',
  SET_SITE_LIST: PREFIX + 'SetSiteList',
  CLEAR: PREFIX + 'Clear'
};

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  UPDATE: 'update',
  UPDATE_RESULT: 'updateResult'
};

// 利用許可属性
const PERMISSION_KEY = exports.PERMISSION_KEY = {
  KAISHA_SOSHIKI_SELECT_ALL: 'kaishasoshiki:select:all_kaisha'
};

// 紐づけ状況コード
const LINKAGE_STATUS_CODE = exports.LINKAGE_STATUS_CODE = {
  ALL: '0',
  COMPLETE: '1',
  NOT_COMPLETE: '2'
};

// 初期状態
const INIT_STATE = {
  // 表示コンテンツ
  dispContent: CONTENTS.MAIN,
  // 検索条件
  searchConditions: {
    kaishaCd: '',
    tdfkCd: '',
    siteNm: '',
    linkageStatus: '0'
  },
  fixedConditions: {
    kaishaCd: '',
    tdfkCd: '',
    siteNm: '',
    linkageStatus: '0'
  },
  // 再検索フラグ
  search: false,
  // 検索結果
  searchResult: [],
  // 検索結果のテーブル表示用
  paging: {
    currentPage: 0,
    viewNum: 50
  },
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  // 更新対象の拠点情報
  siteInfo: {
    hrWorkplaceCd: '',
    hrKaishaCd: '',
    hrKaishaNm: '',
    hrTdfkCd: '',
    hrSiteNm: '',
    hrAddress: '',
    onenecKaishaCd: '',
    onenecKaishaNm: '',
    onenecTdfkCd: '',
    onenecSiteNo: '',
    onenecSiteNm: ''
  },
  // 拠点リスト
  siteList: []
};
const hrLinkageSearchActions = exports.hrLinkageSearchActions = (0, _reduxActions.createActions)({
  [TYPES.GO_MAIN]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_UPDATE]: function () {
    return {
      siteInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CURRENT_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SITE]: function () {
    return {
      onenecSiteNo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SITE_INFO]: function () {
    return {
      siteInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SITE_LIST]: function () {
    return {
      siteList: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.GO_RESULT, TYPES.CLEAR);
const hrLinkageSearchReducer = exports.hrLinkageSearchReducer = (0, _reduxActions.handleActions)({
  [TYPES.GO_MAIN]: (state, action) => {
    let searchConditions;
    if (action.payload.search) {
      searchConditions = state.fixedConditions;
    } else {
      searchConditions = state.searchConditions;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.MAIN,
      search: action.payload.search,
      searchConditions
    });
  },
  [TYPES.GO_UPDATE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    siteInfo: _objectSpread({}, action.payload.siteInfo),
    dispContent: CONTENTS.UPDATE
  }),
  [TYPES.GO_RESULT]: state => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.UPDATE_RESULT
  }),
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    fixedConditions: _objectSpread({}, state.searchConditions),
    search: false
  }),
  [TYPES.CHANGE_CURRENT_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.CHANGE_SITE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    siteInfo: _objectSpread(_objectSpread({}, state.siteInfo), {}, {
      onenecSiteNo: action.payload.onenecSiteNo
    })
  }),
  [TYPES.SET_SITE_INFO]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    siteInfo: _objectSpread(_objectSpread({}, state.siteInfo), action.payload.siteInfo)
  }),
  [TYPES.SET_SITE_LIST]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    siteList: action.payload.siteList
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);